const LANG = 'fi'
const LOCALE = 'fi'

// ? ******************************************************************************************
// ? ******************************************************************************************

const BRANDS = {
  ZMARTA: {
    ID: 2,
    BROKER_ID: -8,
    NAME: 'Zmarta',
    URL: 'https://www.zmarta.fi',
    USER_AGREEMENT_URL: '/ehdot/kayttajasopimus',
    APP_TERMS_URL: '/ehdot/lainavalityspalvelun',
    DATA_CLUB_URL: '/ehdot/suostumus-asiakastiedon-kyselyjarjestelmaan',
    REQUIREMENT_EMAIL: 'info@zmarta.fi',
    PHONE: '(09) 4241 4444'
  },
  BROKER: {
    ID: 1,
    BROKER_ID: -5,
    NAME: 'Freedom Rahoitus',
    URL: 'https://www.freedomrahoitus.fi',
    USER_AGREEMENT_URL: '/tietosuoja/kayttajasopimus',
    APP_TERMS_URL: 'tietosuoja/valityspalvelun-yleiset-ehdot',
    DATA_CLUB_URL: '/tietosuoja/suomen-asiakastiedon-kyselyjarjestelma',
    REQUIREMENT_EMAIL: 'info@freedomrahotius.fi',
    PHONE: '(09) 4241 4400'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const MY_ACCOUNT = {
  BASE: {
    FI: '/hakemukseni',
    EN: '/en/my-pages'
  },
  PRODUCT: {
    FI: '/laina',
    EN: '/consumer-loan'
  },
  OFFERS: {
    FI: '/tarjoukset',
    EN: '/offers'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const AMOUNT_OF_LENDERS = 25

// ? ******************************************************************************************
// ? ******************************************************************************************

const AGE = {
  MAX: 75,
  MIN: 20
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const LOAN_AMOUNT = {
  MIN: 1000,
  MAX: 60000,
  STEP: 1000,
  DEFAULT: 15000,
  LEGAL_TEXT: null
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DURATION = {
  MIN: 1,
  MAX: 15,
  STEP: 1,
  DEFAULT: 8,
  LEGAL_TEXT: null
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PHONE_NO_GROUPING = {
  MIN_LENGTH: 10,
  REGEX: /(\d{3})(\d{3})(\d{4})/,
  OUTPUT: '$1 $2 $3'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const ZOPIM = {
  ZMARTA: null,
  BROKER: null
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const TIME_BASED_EMPLOYMENT = [15]

// ? ******************************************************************************************
// ? ******************************************************************************************

const HAS_EMPLOYMENT = [1, 2, 13, 14, 15]

// ? ******************************************************************************************
// ? ******************************************************************************************

const BANKS_APP_CATEGORY_ID = 2

// ? ******************************************************************************************
// ? ******************************************************************************************

const EXPERIMENT_EVENT_IDS = {
  LOAN_APPLICATION_DECLINED: {
    ZMARTA: 18292303363,
    BROKER: 20415620283
  },
  LOAN_APPLICATION_DUPLICATE: {
    ZMARTA: 18261876452,
    BROKER: 20388474851
  },
  LOAN_APPLICATION_USABLE: {
    ZMARTA: 18265497134,
    BROKER: 20411432291
  },
  LOAN_APPLICATION_FULL: {
    ZMARTA: 18257765178,
    BROKER: 20389738342
  },
  LOAN_APPLICATION_USABLE_CO_APPLICANT: {
    ZMARTA: 20125867494,
    BROKER: 20400410283
  },
  LOAN_APPLICATION_FULL_CO_APPLICANT: {
    ZMARTA: 20184290378,
    BROKER: 20393759802
  },
  LOAN_MYPAGES_READMORE: {
    ZMARTA: 18294294908,
    BROKER: 20425260687
  },
  LOAN_MYPAGES_SELECT: {
    ZMARTA: 18263488646,
    BROKER: 20393779032
  },
  LOAN_MYPAGES_SELECTED: {
    ZMARTA: 22587550655,
    BROKER: 22580310781
  },
  LOAN_MYPAGES_SIGNINGLINK: {
    ZMARTA: 18263475464,
    BROKER: 20336561057
  },
  LOAN_MYPAGES_REFINANCE_CONFIRM: {
    ZMARTA: 21503281364,
    BROKER: 21482820496
  },
  LOAN_MYPAGES_REFINANCE_DECLINE: {
    ZMARTA: 21494580870,
    BROKER: 21513480828
  },
  LOAN_MYPAGES_SELECT_EID_LOGIN: {
    ZMARTA: 22541310570,
    BROKER: 22508800518
  },
  LOAN_APPLICATION_PREFILL_DATA: {
    ZMARTA: 23481881406,
    BROKER: 23547590554
  },
  LOAN_APPLICATION_REAPPLY: {
    ZMARTA: 23525772778,
    BROKER: 23493401989
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PRODUCT_SLUGS = {
  PRIVATE_LOAN: '/vakuudetonlaina',
  REFINANCE_LOAN: '',
  CAR_LOAN: ''
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const SSNS = {
  DECLINED: '110861-999H',
  CF: '080626-998W'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const FIELDS_THAT_ALLOW_0 = [
  'children',
  'monthlyIncome',
  'monthlyNetIncome',
  'spousesMonthlyIncome',
  'spousesMonthlyNetIncome',
  'spousesMonthlyCost',
  'regularMonthlyExpenses'
]

// ? ******************************************************************************************
// ? ******************************************************************************************

const CURRENCY = {
  fi: {
    currency: '€',
    format: '{amount} {currency}'
  },
  en: {
    currency: 'EUR',
    format: '{currency} {amount}'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const NUMBERS = {
  fi: {
    thousandSeparator: ' ',
    decimalSign: ','
  },
  en: {
    thousandSeparator: ',',
    decimalSign: '.'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const RATE = '%'

// ? ******************************************************************************************
// ? ******************************************************************************************

const GOOGLE_ANALYTICS = {
  NAME: {
    ZMARTA: 'owned',
    BROKER: 'freedomrahoitus'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const BANKS = {
  SWEDBANK: 11
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const FIVE_DIGIT_CLEARING_NO = []

// ? ******************************************************************************************
// ? ******************************************************************************************

const ALTERNATE_INTEREST_RATE_LIMIT = 10

// ? ******************************************************************************************
// ? ******************************************************************************************

const URLS = {
  ZMARTA: {
    APPLICATION: '/lainaa-rahaa/yhdista-lainat/hae',
    CONTINUE_APPLICATION: '/lainaa-rahaa/yksityislaina/jatka',
    ADD_CO_APPLICANT: '/lainaa-rahaa/yksityislaina/jatka-co'
  },
  BROKER: {
    APPLICATION: '/vakuudetonlaina/hae',
    CONTINUE_APPLICATION: '/vakuudetonlaina/jatka',
    ADD_CO_APPLICANT: '/vakuudetonlaina/jatka-co'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const REQUIREMENTS = {}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PAYOUT_SPAN = ''

// ? ******************************************************************************************
// ? ******************************************************************************************

const DEBT_DEFAULTS = {
  carLoan: 0,
  chargeCard: 0,
  creditCard: 15,
  mortgage: 0,
  otherLoan: 0,
  studentLoan: 0
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DEBT_REGISTRY_MAP = {
  loan: {},
  credit: {}
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const HIDE_OPTIONS = {
  socialEconomicStatus: [9],
  residenceType: [4],
  residenceOwnershipType: [4],
  otherLoanType: [15]
}

// ? ******************************************************************************************
// ? ******************************************************************************************

module.exports = {
  LANG,
  LOCALE,
  BRANDS,
  MY_ACCOUNT,
  AMOUNT_OF_LENDERS,
  AGE,
  LOAN_AMOUNT,
  DURATION,
  PHONE_NO_GROUPING,
  ZOPIM,
  TIME_BASED_EMPLOYMENT,
  HAS_EMPLOYMENT,
  BANKS_APP_CATEGORY_ID,
  EXPERIMENT_EVENT_IDS,
  PRODUCT_SLUGS,
  SSNS,
  FIELDS_THAT_ALLOW_0,
  CURRENCY,
  NUMBERS,
  GOOGLE_ANALYTICS,
  BANKS,
  FIVE_DIGIT_CLEARING_NO,
  ALTERNATE_INTEREST_RATE_LIMIT,
  URLS,
  REQUIREMENTS,
  RATE,
  PAYOUT_SPAN,
  DEBT_DEFAULTS,
  DEBT_REGISTRY_MAP,
  HIDE_OPTIONS
}
